import React from 'react'

import { LanguageSelector, useLanguageSelectorTranslation } from '@/atoms/LanguageSelector'
import { useTranslation } from '@/lib/i18n/i18n'
import { AppBarMobileCollapse } from '@/organisms/AppBar/AppBar.components'

import { useLanguageSwitcher } from './LanguageSwitcher.hooks'

export const LanguageSwitcherMobile: React.FC = () => {
	const { t } = useTranslation()
	const { onChange, countryLanguages, locale } = useLanguageSwitcher()
	const translation = useLanguageSelectorTranslation()

	return (
		<AppBarMobileCollapse title={<>{translation.title[locale] ?? t('locale-selector.locale')}</>}>
			<LanguageSelector availableLanguages={countryLanguages} language={locale} onChange={onChange} />
		</AppBarMobileCollapse>
	)
}
